import _extends from "@babel/runtime/helpers/extends";
import { useSyncExternalStore } from 'react';
var expands = {};
var listeners = [];
export var store = {
  collapse(id) {
    expands = _extends({}, expands, {
      [id]: false
    });
    emitChange();
  },
  expand(id) {
    expands = _extends({}, expands, {
      [id]: true
    });
    emitChange();
  }
};
function getSnapshot() {
  return expands;
}
function subscribe(listener) {
  listeners = [...listeners, listener];
  return () => {
    listeners = listeners.filter(l => l !== listener);
  };
}
function emitChange() {
  for (var listener of listeners) {
    listener();
  }
}
export function useExpandsStatus() {
  var expands = useSyncExternalStore(subscribe, getSnapshot);
  return expands;
}